export const CopilotWidgetBetaGate = 'Chatspot:Widget:Beta';